module.exports = __webpack_public_path__ + "static/media/laurel.9a456371.png";